import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button.jsx';
import Container from '../components/Container.jsx';

function NotFound() {
  return (
    <Container className="flex-1 flex flex-col items-center justify-center text-center py-16">
      <div className="max-w-lg mx-auto">
        <h1 className="text-6xl font-heading font-black mb-6 text-primary">404</h1>
        <h2 className="text-2xl font-heading font-bold mb-4 text-text-primary">
          Cette page n'existe pas
        </h2>
        <p className="text-lg text-text-secondary mb-8">
          Désolé, la page que vous recherchez est introuvable. 
          Elle a peut-être été déplacée ou supprimée.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="primary" size="lg">
              Retour à l'accueil
            </Button>
          </Link>
          <Link to="/products">
            <Button variant="secondary" size="lg">
              Voir nos produits
            </Button>
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default NotFound;
